import React, { createContext, useContext, useEffect, useState } from "react";
import panelApi, { setPanelToken, getPanelToken } from "@/lib/panelApi";

const Ctx = createContext({ user: null, loading: true, login: async () => {}, register: async () => {}, logout: () => {} });

export function AcenteAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getPanelToken()) {
      setLoading(false);
      return;
    }
    panelApi
      .get("/me")
      .then((r) => setUser(r.data))
      .catch(() => setPanelToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await panelApi.post("/login", { email, password });
    setPanelToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await panelApi.post("/register", payload);
    setPanelToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setPanelToken(null);
    setUser(null);
  };

  return <Ctx.Provider value={{ user, loading, login, register, logout }}>{children}</Ctx.Provider>;
}

export const useAcenteAuth = () => useContext(Ctx);
